import { Reveal } from "../shared";

export function LandingBlocks({ blocks }) {
  return (
    <section className="py-24 lg:py-32 bg-[#0D0D0D]" data-testid="landing-blocks">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-[1fr_2fr] gap-10 lg:gap-20">
        <Reveal>
          <ol className="lg:sticky lg:top-28 space-y-3 hidden lg:block" aria-label="On this page">
            {blocks.map((b, i) => (
              <li key={b.heading} className="text-[11px] uppercase tracking-[0.2em] text-[#71717A]">
                <span className="text-[#D4AF37] mr-3">{String(i + 1).padStart(2, "0")}</span>{b.heading}
              </li>
            ))}
          </ol>
        </Reveal>
        <div className="space-y-14">
          {blocks.map((b, i) => (
            <Reveal key={b.heading} delay={0.05}>
              <article data-testid={`landing-block-${i}`}>
                <h2 className="font-serif-lux text-2xl sm:text-3xl text-[#F5F5F0] mb-4">{b.heading}</h2>
                <p className="text-sm sm:text-base text-[#A1A1AA] leading-relaxed">{b.body}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
